// Styles d'icônes disponibles
export const ICON_STYLES = {
  flat: {
    label: 'Flat',
    icons: {
      linkedin: 'https://cdn-icons-png.flaticon.com/512/174/174857.png',
      x: 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png', // Logo X (nouveau Twitter)
      facebook: 'https://cdn-icons-png.flaticon.com/512/733/733547.png',
      instagram: 'https://cdn-icons-png.flaticon.com/512/733/733558.png',
      youtube: 'https://cdn-icons-png.flaticon.com/512/733/733646.png',
      github: 'https://cdn-icons-png.flaticon.com/512/733/733553.png',
      tiktok: 'https://cdn-icons-png.flaticon.com/512/3046/3046121.png',
      pinterest: 'https://cdn-icons-png.flaticon.com/512/733/733614.png',
      whatsapp: 'https://cdn-icons-png.flaticon.com/512/733/733585.png',
      telegram: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png'
    }
  },
  rounded: {
    label: 'Arrondi',
    icons: {
      linkedin: 'https://cdn-icons-png.flaticon.com/512/3536/3536505.png',
      x: 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png',
      facebook: 'https://cdn-icons-png.flaticon.com/512/1384/1384005.png',
      instagram: 'https://cdn-icons-png.flaticon.com/512/1384/1384015.png',
      youtube: 'https://cdn-icons-png.flaticon.com/512/1384/1384012.png',
      github: 'https://cdn-icons-png.flaticon.com/512/3291/3291695.png',
      tiktok: 'https://cdn-icons-png.flaticon.com/512/3669/3669950.png',
      pinterest: 'https://cdn-icons-png.flaticon.com/512/1384/1384010.png',
      whatsapp: 'https://cdn-icons-png.flaticon.com/512/1384/1384007.png',
      telegram: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png'
    }
  },
  color: {
    label: 'Coloré',
    icons: {
      linkedin: 'https://cdn-icons-png.flaticon.com/512/3536/3536505.png',
      x: 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png',
      facebook: 'https://cdn-icons-png.flaticon.com/512/124/124010.png',
      instagram: 'https://cdn-icons-png.flaticon.com/512/2111/2111463.png',
      youtube: 'https://cdn-icons-png.flaticon.com/512/1384/1384060.png',
      github: 'https://cdn-icons-png.flaticon.com/512/733/733609.png',
      tiktok: 'https://cdn-icons-png.flaticon.com/512/3046/3046126.png',
      pinterest: 'https://cdn-icons-png.flaticon.com/512/145/145808.png',
      whatsapp: 'https://cdn-icons-png.flaticon.com/512/124/124034.png',
      telegram: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png'
    }
  },
  circle: {
    label: 'Cercle',
    icons: {
      linkedin: 'https://cdn-icons-png.flaticon.com/512/145/145807.png',
      x: 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png',
      facebook: 'https://cdn-icons-png.flaticon.com/512/145/145802.png',
      instagram: 'https://cdn-icons-png.flaticon.com/512/145/145805.png',
      youtube: 'https://cdn-icons-png.flaticon.com/512/1384/1384028.png',
      github: 'https://cdn-icons-png.flaticon.com/512/733/733609.png',
      tiktok: 'https://cdn-icons-png.flaticon.com/512/3046/3046126.png',
      pinterest: 'https://cdn-icons-png.flaticon.com/512/145/145808.png',
      whatsapp: 'https://cdn-icons-png.flaticon.com/512/145/145806.png',
      telegram: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png'
    }
  }
};

export const SOCIAL_NETWORKS = {
  linkedin: {
    name: 'LinkedIn',
    color: '#0077B5',
    placeholder: 'https://linkedin.com/in/username'
  },
  x: {
    name: 'X (Twitter)',
    color: '#000000',
    placeholder: 'https://x.com/username'
  },
  facebook: {
    name: 'Facebook',
    color: '#1877F2',
    placeholder: 'https://facebook.com/username'
  },
  instagram: {
    name: 'Instagram',
    color: '#E4405F',
    placeholder: 'https://instagram.com/username'
  },
  youtube: {
    name: 'YouTube',
    color: '#FF0000',
    placeholder: 'https://youtube.com/@username'
  },
  github: {
    name: 'GitHub',
    color: '#181717',
    placeholder: 'https://github.com/username'
  },
  tiktok: {
    name: 'TikTok',
    color: '#000000',
    placeholder: 'https://tiktok.com/@username'
  },
  pinterest: {
    name: 'Pinterest',
    color: '#E60023',
    placeholder: 'https://pinterest.com/username'
  },
  whatsapp: {
    name: 'WhatsApp',
    color: '#25D366',
    placeholder: 'https://wa.me/number'
  },
  telegram: {
    name: 'Telegram',
    color: '#0088CC',
    placeholder: 'https://t.me/username'
  }
};

// Fonction helper pour obtenir l'icône selon le style
export const getSocialIcon = (network, iconStyle = 'flat') => {
  return ICON_STYLES[iconStyle]?.icons[network] || ICON_STYLES.flat.icons[network];
};
